import React, { FC, useState, useEffect } from 'react';
import { SCUIButton, SCUILoadingLinear, SCUINoRecordComponent } from '../../../atomic/atoms';
import { SCUIContent } from '../../../atomic/organisms';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { useTranslation } from 'react-i18next';
import { SCUICreateReturnModal, SCUICreateReturnFilterDrawerContent } from '../ReturnList/components';
import {
    SCUICustomDataGrid,
    SCUIGeneralDrawer,
    SCUITextFieldWithSelectBox,
    SCUIBreadCrumb,
} from '../../../atomic/molecules';
import {
    Card,
    CardContent,
    Chip,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    TableHead,
    Typography,
    Tooltip,
    Box,
    Stack,
    IconButton,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { ReturnCommand } from '../../../services/command';
import IndexedDbWrapper from '../../../core/wrappers/browserStorage/indexedDb-wrapper';
import TimeHelper from '../../../utils/time';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { getCachedSearched, addToCache, initialState, ReturnDetailFilter } from './ReturnList.helper';
import { ReturnQuery } from '../../../services/query';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import HistoryIcon from '@mui/icons-material/History';
import Swal from 'sweetalert2';
import { enumReturnStatus } from '../../../types/enums/status';
import Helper from '../../../utils/helper';
import { buildURLFromObject } from '../ReturnDetail/ReturnDetail.helper';
import InfoIcon from '@mui/icons-material/Info';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import SCUIDownloadButton from '../../../atomic/atoms/SCUIDownloadButton/SCUIDownloadButton';
import { useSelector } from 'react-redux';
import { buildReturnListFilterChips } from './returnListFilterChips.helper';

export const ReturnList: FC<any> = () => {
    const [pageSize, setPageSize] = React.useState(10);
    const [pageNumber, setPageNumber] = React.useState(0);
    const [rowCount, setRowCount] = React.useState(0);
    const [returnStatus, setReturnStatus] = useState<any>();
    const [loading, setLoading] = useState(false);
    const params = new URLSearchParams(window.location.search);
    const [returnDetailFilterInput, setReturnDetailFilterInput] = useState<ReturnDetailFilter>(
        initialState.returnDetailFilterInput
    );
    useEffect(() => {
        const updatedState: Partial<ReturnDetailFilter> = {
            ...returnDetailFilterInput,
        };
        params.forEach((value, key) => {
            if (key in returnDetailFilterInput) {
                // Recognize 'key' as one of the keys from ReturnDetailFilter

                updatedState[key as keyof ReturnDetailFilter] = value as any;
            }
        });
        setReturnDetailFilterInput((prevState) => ({
            ...prevState,
            ...updatedState,
        }));
    }, []);

    const { t } = useTranslation();
    const [documentType, setDocumentType] = useState(2);
    const history = useHistory();
    const [listModalOpen, setListModalOpen] = useState(false);
    const [searchedText, setSearchedText] = useState('');
    const [cachedSearchedValues, setCachedSearchedValues] = React.useState<any>();
    const [datas, setDatas] = React.useState<any>();
    const onDrawerOpen = () => setDrawerOpen(true);
    const onDrawerClose = () => setDrawerOpen(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [paginationModeChange, setPaginationModeChange] = useState(false);
    const handleCloseModal = () => {
        setListModalOpen(false);
    };
    const handleOpenModal = () => {
        setListModalOpen(true);
    };
    const [searchedOrderNotFound, setSearchedOrderNotFound] = React.useState<any>();
    const [returnSearchInput, setReturnSearchInput] = useState(initialState.returnSearchInput);
    const [isActiveReturnRequest, setIsActiveReturnRequest] = React.useState<any>();
    const [selectedBarcodes, setSelectedBarcodes] = useState([]);
    const [openBarkodModal, setOpenBarkodModal] = useState(false);
    const [excelDownloadDatas, setExcelDownloadDatas] = React.useState<any>();
    const returnStatusList = [1, 2, 3, 5, 6, 7, 8, 9];

    const [refresh, setRefresh] = useState(false);
    const countryStore: any = useSelector((state: any) => state?.country);
    const [canCreateRefund, setCanCreateRefund] = useState<boolean | null>(null);
    const [canCreateRefundLoading, setCanCreateRefundLoading] = useState<boolean>(true);

    useEffect(() => {
        let storeCode = Helper.getStoreCode();
        if (storeCode) {
            setDocumentType(1);
        }
    }, []);

    useEffect(() => {
        const checkCanCreateRefund = async () => {
            try {
                setCanCreateRefundLoading(true);
                const response = await ReturnQuery.CanStoreUserCreateRefund();
                const canCreate = typeof response === 'boolean' ? response : (response?.data ?? true);
                setCanCreateRefund(canCreate);
            } catch (error) {
                console.error('Error checking refund permission:', error);
                setCanCreateRefund(true);
            } finally {
                setCanCreateRefundLoading(false);
            }
        };
        checkCanCreateRefund();
    }, []);
    useEffect(() => {
        if (datas) {
            setIsActiveReturnRequest(
                datas.some((item: any) => [0, 1, 2].includes(item.returnStatus) || [0, 1, 2].includes(item.status))
            ); // statu 0,1 veya 2 ise aktif talep var yazıyor
            const updatedDatas = datas.map((item: any) => {
                let itemBarcodes: any = [];
                if (item?.returnItems && item?.returnItems?.length > 0)
                    itemBarcodes = item.returnItems.flatMap((subItem: any) => subItem.barcodes).join(', ');
                return {
                    returnDate: TimeHelper.formatDateHour(item.returnDate),
                    saleOrderNumber: item.saleOrderNumber,
                    rmaCode: String(item.rmaCode),
                    orderId: item.orderId,
                    cityName: item.senderCityName,
                    name: item.storeCode,
                    barcode: itemBarcodes,
                    customer: item.customerId,
                    returnId: item.returnId,
                    status: item.statusDescription,
                };
            });
            setExcelDownloadDatas(updatedDatas);
        }
    }, [datas]);
    useEffect(() => {
        if (searchedText?.length > 0 && searchedText?.length < 20) {
            if (searchedText.startsWith('QR_')) {
                const rmaCodeWithoutPrefix = searchedText.substring(3);
                setDocumentType(2);
                localStorage.setItem(
                    'rmaCodeWithQRCode',
                    JSON.stringify({
                        rmaCodeWithoutPrefix: rmaCodeWithoutPrefix,
                        IsQRCodeUse: true,
                    })
                );
                setSearchedText(rmaCodeWithoutPrefix);
            } else if (searchedText.startsWith('48') && countryStore.country === 8) {
                setDocumentType(4); // CargoReturnCode
            } else if (searchedText.startsWith('2')) {
                setDocumentType(1);
            } else if (searchedText.startsWith('5')) {
                if (searchedText?.length === 13) {
                    setDocumentType(3);
                } else if (searchedText?.length < 13) {
                    setDocumentType(4);
                }
            } else if (searchedText.startsWith('4')) {
                setDocumentType(2);
            }
        }
    }, [searchedText, countryStore]);
    const handleOpenBarkodModal = (barcodes: any) => {
        setSelectedBarcodes(barcodes);
        setOpenBarkodModal(true);
    };

    const handleCloseBarkodModal = () => {
        setOpenBarkodModal(false);
    };

    const checkStatusInList = (status: number) => {
        return returnStatusList.includes(status);
    };
    const fetchTrackingInfo = async (returnId: number, rmaCode: string) => {
        try {
            const res = await ReturnCommand.GetReturnTrackingInfo({ returnId, rmaCode });

            if (res && res.trackingUrl != '') {
                window.open(res.trackingUrl, '_blank', 'noopener,noreferrer');
            } else {
                Swal.fire(t('return.trackingUrlError'), '', 'error');
            }
        } catch (error) {
            console.error('Error fetching tracking URL:', error);
        }
    };
    const handleLinkClick = (returnId: number, rmaCode: string) => {
        fetchTrackingInfo(returnId, rmaCode);
    };

    const handleClick = (params: any) => {
        const url = `returnDetail/?ReturnId=${params.row.returnId}&customerId=${params.row.customerId}`;
        const state = {
            returnId: params.row.returnId,
            customerId: params.row.customerId,
            filterParams: returnDetailFilterInput,
            datas: datas,
            rowCount: rowCount,
        };

        // State verilerini localStorage'a kaydet
        localStorage.setItem('returnDetailState', JSON.stringify(state));

        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) {
            newWindow.opener = null;
        }
    };

    const columns: ExtendedGridColDef[] = [
        {
            field: 'returnDate',
            headerName: t('return.returnDate'),
            flex: 1,
            maxWidth: 120,
            renderCell(params) {
                return <p>{TimeHelper.formatDateHour(params.row.returnDate)}</p>;
            },
        },
        {
            field: 'saleOrderNumber',
            headerName: t('general.orderNo'),
            flex: 1,
            maxWidth: 100,
            renderCell: (params) => {
                const onclick = () => {
                    window.open(
                        import.meta.env.VITE_APPURL! + '/orderDetail?OrderNumber=' + params.row.saleOrderNumber,
                        '_blank'
                    );
                };
                return (
                    <div>
                        <p className="linktxt" onClick={onclick}>
                            <b>{params.row.saleOrderNumber}</b>
                        </p>
                    </div>
                );
            },
        },
        { field: 'rmaCode', headerName: t('return.RMACode'), flex: 1, maxWidth: 100 },
        { field: 'orderId', headerName: t('general.orderId'), flex: 1, maxWidth: 85 },
        { field: 'senderCityName', headerName: t('general.cityName'), flex: 1, maxWidth: 90 },
        { field: 'storeCode', headerName: t('general.storeName'), flex: 1, maxWidth: 90 },
        {
            field: 'barcodes',
            headerName: t('return.barcodes'),
            maxWidth: 80,
            flex: 1,
            renderCell: (params) => {
                if (params?.row?.returnItems && params?.row?.returnItems?.length > 0) {
                    const allBarcodes = params.row.returnItems.flatMap((item: any) => item.barcodes);
                    return (
                        allBarcodes && (
                            <div onClick={() => handleOpenBarkodModal(allBarcodes)}>
                                <InfoIcon style={{ color: '#5b99f3', cursor: 'pointer' }} />
                            </div>
                        )
                    );
                }
            },
        },
        {
            field: 'customerId',
            headerName: t('refundList.customer'),
            flex: 1,
            maxWidth: 100,
            hide: false,
            renderCell: (params) => {
                const onclick = () => {
                    window.open(
                        import.meta.env.VITE_APPURL! + '/customerManagement?customerId=' + params.row.customerId,
                        '_blank'
                    );
                };
                return (
                    <div>
                        <p className="linktxt" onClick={onclick}>
                            <b>
                                {params.row.customerFullName && params.row.customerFullName?.length > 0
                                    ? Helper.maskName(params.row.customerFullName)
                                    : params.row.customerId}
                            </b>{' '}
                        </p>
                    </div>
                );
            },
        },
        {
            field: 'returnId',
            headerName: t('return.returnId'),
            flex: 1,
            maxWidth: 100,
        },
        {
            field: 'returnStatusDescription',
            headerName: t('general.status'),
            flex: 1,
            maxWidth: 170,
            renderCell(params) {
                return (
                    <div>
                        {params.row.returnStatusDescription ? (
                            <p
                                style={{
                                    color: enumReturnStatus[params.row.returnStatus]?.colorCode,
                                    fontWeight: 'bold',
                                }}
                            >
                                {params.row.returnStatusDescription}
                            </p>
                        ) : (
                            <p style={{ color: enumReturnStatus[params.row.status]?.colorCode, fontWeight: 'bold' }}>
                                {params.row.statusDescription}
                            </p>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'saleOrderDeliveryDate',
            headerName: t('return.deliveryDate'),
            flex: 1,
            hide: true,
        },

        { field: 'saleOrderId', headerName: 'saleOrderId', flex: 1, hide: true },
        {
            field: 'customerFullName',
            headerName: 'customerFullName',
            flex: 1,
            hide: true,
        },
        {
            field: 'status',
            headerName: t('return.returnCargo'),
            flex: 1,
            maxWidth: 150,
            renderCell(params) {
                const status = params.row.status != null ? params.row.status : params.row.returnStatus;
                const statusExists = checkStatusInList(status);
                return (
                    <div>
                        {statusExists ? (
                            <Tooltip title={t('orderDetail.cargoTracking')}>
                                <Typography
                                    color="default"
                                    onClick={() => handleLinkClick(params.row.returnId, params.row.rmaCode)}
                                    style={{
                                        padding: '4px',
                                        color: '#03a9f4',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {t('orderDetail.cargoTracking')}
                                </Typography>
                            </Tooltip>
                        ) : null}
                    </div>
                );
            },
        },
        {
            field: '  ',
            headerName: '',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            maxWidth: 100,
            renderCell: (params: any) => {
                return (
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handleClick(params);
                        }}
                    >
                        <p className="linktxt">{t('general.show')}</p>
                    </a>
                );
            },
        },
    ];

    async function deleteCachedSearched(id: number) {
        IndexedDbWrapper.deleteItemFromDb('returnRequests', id);
        getCachedSearched();
        setRefresh((prevLoading) => !prevLoading);
    }

    const handleClear = async () => {
        const cachedOrders = await getCachedSearched();
        for (const searchList of cachedOrders) {
            await IndexedDbWrapper.deleteItemFromDb('returnRequests', searchList.id);
        }
        setCachedSearchedValues([]);
    };

    const showLastSearched = async () => {
        setDatas(null);
        await getCachedSearchedValues();
        setRefresh((prevLoading) => !prevLoading);
    };

    const CHIP_COLORS = [
        { bg: 'rgba(25,118,210,0.07)', border: 'rgba(25,118,210,0.28)', icon: '#1976d2' },
        { bg: 'rgba(0,150,136,0.07)', border: 'rgba(0,150,136,0.28)', icon: '#00897b' },
        { bg: 'rgba(103,58,183,0.07)', border: 'rgba(103,58,183,0.28)', icon: '#7b1fa2' },
        { bg: 'rgba(230,81,0,0.07)', border: 'rgba(230,81,0,0.28)', icon: '#e65100' },
        { bg: 'rgba(48,63,159,0.07)', border: 'rgba(48,63,159,0.28)', icon: '#283593' },
        { bg: 'rgba(27,94,32,0.07)', border: 'rgba(27,94,32,0.28)', icon: '#2e7d32' },
        { bg: 'rgba(0,131,143,0.07)', border: 'rgba(0,131,143,0.28)', icon: '#00838f' },
        { bg: 'rgba(173,20,87,0.07)', border: 'rgba(173,20,87,0.28)', icon: '#ad1457' },
        { bg: 'rgba(191,54,12,0.07)', border: 'rgba(191,54,12,0.28)', icon: '#bf360c' },
        { bg: 'rgba(78,52,46,0.07)', border: 'rgba(78,52,46,0.28)', icon: '#4e342e' },
    ];

    const buildFilterChips = (request: any) => buildReturnListFilterChips(request, t, returnStatus);

    const GetReturnStatus = () => {
        ReturnQuery.GetReturnStatus().then((res: any) => {
            setReturnStatus(res.data && [...[{ returnStatusId: -1, statusNameKey: t('general.all') }], ...res.data]);
        });
    };

    useEffect(() => {
        // Wait for permission check to complete before searching
        if (canCreateRefundLoading) {
            return;
        }

        if (JSON.stringify(returnSearchInput) !== JSON.stringify(initialState.returnSearchInput)) {
            listeleReturnList();
        }
    }, [returnSearchInput, canCreateRefundLoading]);
    useEffect(() => {
        // Wait for permission check to complete before searching
        if (canCreateRefundLoading) {
            return;
        }

        if (JSON.stringify(returnDetailFilterInput) !== JSON.stringify(initialState.returnDetailFilterInput)) {
            listele();
        }
    }, [returnDetailFilterInput, canCreateRefundLoading]);

    useEffect(() => {
        GetReturnStatus();
    }, []);

    const orderNotFound = (val: any) => {
        // Don't show alert if permission check is still loading
        if (canCreateRefundLoading) {
            return;
        }

        if (!canCreateRefund) {
            // User doesn't have permission - show simple warning with only OK button
            Swal.fire({
                text: t('return.noActiveReturnRequestNoPermission'),
                icon: 'warning',
                confirmButtonText: t('general.ok'),
            });
        } else {
            // User has permission - show original warning with create request option
            Swal.fire({
                text: t('return.noActiveReturnRequest'),
                cancelButtonText: t('general.cancel'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t('return.createRequest'),
            }).then((result: any) => {
                if (result.isConfirmed) {
                    handleOpenModal();
                    setSearchedOrderNotFound(val);
                }
            });
        }
    };

    const getCachedSearchedValues = async () => {
        const cachedOrders: any = await getCachedSearched();
        if (cachedOrders?.length <= 10) {
            setCachedSearchedValues(cachedOrders.reverse());
        } else {
            setCachedSearchedValues(cachedOrders.slice(Math.max(cachedOrders.length - 10, 1)).reverse());
        }
    };

    const listele = async () => {
        setLoading(true);
        addToCache(returnDetailFilterInput);
        const newUrl = buildURLFromObject(returnDetailFilterInput);
        history.push(newUrl);
        let params = {
            ...returnDetailFilterInput,
            Barcodes: returnDetailFilterInput.Barcodes ? returnDetailFilterInput.Barcodes.split(',') : [],
        };
        ReturnCommand.SearchReturn(params)
            .then((res: any) => {
                if (res.data) {
                    if (res.data.length > 0) {
                        let parseData = res.data;
                        setRowCount(res.count);
                        setPaginationModeChange(true);
                        setDatas(parseData);

                        if (parseData.length === 1) {
                            let path = `returnDetail`;
                            history.replace('/returnList');
                            history.push(
                                path + '/?ReturnId=' + parseData[0].returnId + '&customerId=' + parseData[0].customerId,
                                {
                                    returnId: parseData[0].returnId,
                                    customerId: parseData[0].customerId,
                                }
                            );
                        }
                    } else if (returnDetailFilterInput.OrderNumber) orderNotFound(returnDetailFilterInput);
                    else if (returnDetailFilterInput.ShippingListNo) orderNotFound(returnDetailFilterInput);
                    else {
                        setDatas([]);
                    }
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const listeleReturnList = async () => {
        setLoading(true);
        addToCache(returnSearchInput);
        const newUrl = buildURLFromObject(returnSearchInput);
        history.push(newUrl);
        ReturnCommand.PostGetReturnList(returnSearchInput)
            .then((res: any) => {
                if (res.returnModels && res.returnModels.length > 0) {
                    let parseData = res.returnModels;
                    setRowCount(res.count);
                    setPaginationModeChange(false);
                    setDatas(parseData);
                    if (parseData.length === 1) {
                        let path = `returnDetail`;
                        history.replace('/returnList');
                        history.push(
                            path +
                                '/?ReturnId=' +
                                res.returnModels[0].returnId +
                                '&customerId=' +
                                res.returnModels[0].customerId,
                            {
                                returnId: res.returnModels[0].returnId,
                                customerId: res.returnModels[0].customerId,
                            }
                        );
                    }
                } else {
                    orderNotFound(returnSearchInput);
                    setDatas([]);
                }
            })
            .catch((error: any) => {
                setDatas([]);
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        (async () => {
            const cachedOrders = await getCachedSearched();
            if (cachedOrders?.length <= 10) {
                setCachedSearchedValues(cachedOrders.reverse());
            } else {
                setCachedSearchedValues(cachedOrders.slice(Math.max(cachedOrders.length - 10, 1)).reverse());
            }
        })();
    }, [refresh]);

    const selectListOptions = [
        { value: 1, text: t('general.orderNo') },
        { value: 2, text: t('general.returnRequestNumber') },
        { value: 3, text: t('general.shippingNumber') },
        { value: 4, text: t('general.cargoReturnCode') },
    ];
    return (
        <>
            {selectedBarcodes && (
                <Dialog open={openBarkodModal} onClose={handleCloseBarkodModal}>
                    <Card sx={{ boxShadow: 3 }}>
                        <DialogTitle style={{ textAlign: 'center' }}>{t('general.barcodes')}</DialogTitle>
                        <DialogContent>
                            <CardContent>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>#</TableCell>
                                            <TableCell>{t('general.barcodeNumber')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedBarcodes.map((barcode, index) => (
                                            <TableRow key={barcode}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{barcode}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <div style={{ height: '1px', backgroundColor: 'lightgray' }}></div>
                                <p
                                    style={{
                                        color: 'lightgray',
                                        fontSize: '10px',
                                        textAlign: 'right',
                                    }}
                                >
                                    {`Toplam Barkod Sayısı: ${selectedBarcodes?.length}`}
                                </p>
                            </CardContent>
                        </DialogContent>
                    </Card>
                </Dialog>
            )}
            <SCUIContent>
                <SCUICreateReturnModal
                    open={listModalOpen}
                    onClose={handleCloseModal}
                    searchedOrderNotFound={searchedOrderNotFound}
                />
                <SCUIGeneralDrawer
                    open={drawerOpen}
                    width={'360px'}
                    sx={{ '& .MuiDrawer-paper': { paddingTop: '16px' } }}
                    onClose={(event: any, reason: any) => {
                        if (reason === 'backdropClick') {
                            setDrawerOpen(false);
                        }
                    }}
                >
                    <SCUICreateReturnFilterDrawerContent
                        onClose={onDrawerClose}
                        setReturnDetailFilterInput={setReturnDetailFilterInput}
                        returnStatus={returnStatus}
                    />
                </SCUIGeneralDrawer>
                <Grid className="return-list" container direction="row" spacing={2}>
                    <SCUIBreadCrumb title={t('dashboard.returnRequests')} componentLink={'returnList'} />
                    <SCUILoadingLinear display={loading} />
                    <Grid
                        className="searchedText return-list-search-input"
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 6,
                            xl: 6,
                        }}
                    >
                        <SCUITextFieldWithSelectBox
                            autoFocus={true}
                            selectList={selectListOptions}
                            onChangeSelect={(event: any) => {
                                setDocumentType(event.target.value as number);
                            }}
                            selectValue={documentType}
                            onChangeTextField={(event: any) => {
                                setSearchedText(event.target.value.trim());
                            }}
                            onClickButton={() => {
                                if (documentType === 1) {
                                    setReturnSearchInput({
                                        ...initialState.returnSearchInput,
                                        OrderNumber: searchedText,
                                    });
                                } else if (documentType === 2) {
                                    setReturnSearchInput({
                                        ...initialState.returnSearchInput,
                                        RMACode: Number(searchedText),
                                    });
                                } else if (documentType === 3) {
                                    setReturnSearchInput({
                                        ...initialState.returnSearchInput,
                                        ShippingListNo: searchedText,
                                    });
                                } else if (documentType === 4) {
                                    setReturnSearchInput({
                                        ...initialState.returnSearchInput,
                                        CargoReturnCode: searchedText,
                                    } as any); // type hatası olmaması için
                                }
                            }}
                            onKeyPressTextField={(e: any) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    if (documentType === 1) {
                                        setReturnSearchInput({
                                            ...initialState.returnSearchInput,
                                            OrderNumber: searchedText,
                                        });
                                    } else if (documentType === 2) {
                                        setReturnSearchInput({
                                            ...initialState.returnSearchInput,
                                            RMACode: Number(searchedText),
                                        });
                                    } else if (documentType === 3) {
                                        setReturnSearchInput({
                                            ...initialState.returnSearchInput,
                                            ShippingListNo: searchedText,
                                        });
                                    } else if (documentType === 4) {
                                        setReturnSearchInput({
                                            ...initialState.returnSearchInput,
                                            CargoReturnCode: searchedText,
                                        } as any);
                                    }
                                }
                            }}
                        />
                    </Grid>
                    {canCreateRefund && (
                        <Grid
                            className="return-list-action-buttons"
                            size={{
                                xs: 12,
                                md: 6,
                                lg: 6,
                                xl: 6,
                            }}
                        >
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <SCUIButton
                                    className="return-list-last-searched-button"
                                    style={{ height: '40px', padding: '0 16px' }}
                                    text={t('order.lastSearched')}
                                    type="secondary"
                                    sizeType="fixed"
                                    size={'s'}
                                    showStartIcon
                                    startIcon={<HistoryIcon style={{ fontSize: '15px' }} />}
                                    onClick={() => showLastSearched()}
                                />
                                <SCUIButton
                                    className="return-list-detailed-search-button"
                                    style={{ height: '40px', padding: '0 16px' }}
                                    text={t('general.detailedSearch')}
                                    type="primary"
                                    sizeType="fixed"
                                    size={'s'}
                                    showStartIcon
                                    startIcon={<SearchIcon style={{ fontSize: '15px' }} />}
                                    onClick={() => onDrawerOpen()}
                                />
                                <SCUIButton
                                    className="return-list-create-return-request-button"
                                    style={{ height: '40px', padding: '0 16px' }}
                                    text={t('general.createReturnRequest')}
                                    type="primary"
                                    sizeType="fixed"
                                    size={'s'}
                                    showStartIcon
                                    startIcon={
                                        <AddCircleOutlineIcon style={{ fontSize: '15px', marginRight: '8px' }} />
                                    }
                                    onClick={() => {
                                        setSearchedOrderNotFound(null);
                                        handleOpenModal();
                                    }}
                                />
                            </Box>
                        </Grid>
                    )}
                    <Grid
                        sx={{ paddingLeft: 2 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <Typography variant="caption" display="block" gutterBottom>
                            {t('return.returnNote')}
                        </Typography>
                    </Grid>
                    {isActiveReturnRequest && (
                        <Grid
                            sx={{ paddingLeft: 2 }}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <Typography variant="caption" display="block" gutterBottom color="red">
                                <b>{t('return.activeReturnRequestMessage')} </b>
                            </Typography>
                        </Grid>
                    )}
                </Grid>
                {datas ? (
                    <Grid container direction="row" sx={{ marginLeft: '0.5rem' }}>
                        <Grid
                            sx={{ margin: '1rem' }}
                            size={{
                                xl: 8,
                                lg: 9,
                                md: 6,
                                xs: 6,
                            }}
                        >
                            <h1 className="headtxt">{t('general.requests')} </h1>
                        </Grid>
                    </Grid>
                ) : (
                    <Box sx={{ mt: 3 }}>
                        {!loading && cachedSearchedValues && cachedSearchedValues.length > 0 ? (
                            <>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        mb: 3,
                                        pb: 2,
                                        borderBottom: '2px solid',
                                        borderColor: 'divider',
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <HistoryIcon sx={{ color: 'text.primary', fontSize: 22 }} />
                                        <Typography
                                            variant="h6"
                                            fontWeight={800}
                                            color="text.primary"
                                            fontSize={16}
                                            letterSpacing={0.2}
                                        >
                                            {t('general.recentlySearched')}
                                        </Typography>
                                        <Chip
                                            label={cachedSearchedValues.length}
                                            size="small"
                                            sx={{
                                                height: 22,
                                                fontSize: 12,
                                                fontWeight: 800,
                                                backgroundColor: 'grey.200',
                                                color: 'text.primary',
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <SCUIButton
                                            className="return-list-clear-list-button"
                                            style={{ height: '34px', padding: '0 16px' }}
                                            text={t('general.clearList')}
                                            type="secondary"
                                            sizeType="fixed"
                                            size={'s'}
                                            showStartIcon
                                            startIcon={<DeleteIcon style={{ fontSize: '15px' }} />}
                                            onClick={() => handleClear()}
                                        />
                                    </Box>
                                </Box>

                                <Stack spacing={1.5}>
                                    {cachedSearchedValues.map((cachedVal: any, idx: number) => {
                                        const chips = buildFilterChips(cachedVal.request);
                                        return (
                                            <Card
                                                key={cachedVal.id}
                                                elevation={0}
                                                onClick={() => setReturnDetailFilterInput(cachedVal.request)}
                                                sx={{
                                                    border: '1px solid',
                                                    borderColor: 'grey.200',
                                                    borderLeft: '4px solid',
                                                    borderLeftColor: 'grey.400',
                                                    borderRadius: 2.5,
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                    '&:hover': {
                                                        borderColor: 'grey.300',
                                                        borderLeftColor: 'primary.main',
                                                        boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                                                        transform: 'translateY(-1px)',
                                                        backgroundColor: 'grey.50',
                                                    },
                                                }}
                                            >
                                                <CardContent sx={{ py: 2, px: 2.5, '&:last-child': { pb: 2 } }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'flex-start',
                                                            justifyContent: 'space-between',
                                                            gap: 2,
                                                        }}
                                                    >
                                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 1,
                                                                    mb: 1.5,
                                                                }}
                                                            >
                                                                <HistoryIcon sx={{ fontSize: 14, color: 'grey.500' }} />
                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    fontWeight={700}
                                                                    fontSize={12}
                                                                >
                                                                    {TimeHelper.formatDateHour(cachedVal.insert_date)}
                                                                </Typography>
                                                                <Chip
                                                                    label={`#${cachedSearchedValues.length - idx}`}
                                                                    size="small"
                                                                    sx={{
                                                                        height: 20,
                                                                        fontSize: 10,
                                                                        borderRadius: 1,
                                                                        fontWeight: 800,
                                                                        backgroundColor: 'grey.100',
                                                                        color: 'text.secondary',
                                                                    }}
                                                                />
                                                            </Box>
                                                            {chips.length > 0 ? (
                                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                                    {chips.map((chip, chipIdx) => {
                                                                        const c =
                                                                            CHIP_COLORS[
                                                                                chip.colorKey % CHIP_COLORS.length
                                                                            ];
                                                                        return (
                                                                            <Chip
                                                                                key={chipIdx}
                                                                                icon={chip.icon}
                                                                                label={
                                                                                    <span>
                                                                                        <strong>{chip.tooltip}:</strong>{' '}
                                                                                        {chip.value}
                                                                                    </span>
                                                                                }
                                                                                size="medium"
                                                                                sx={{
                                                                                    fontSize: 12,
                                                                                    height: 32,
                                                                                    fontWeight: 500,
                                                                                    backgroundColor: c.bg,
                                                                                    color: 'text.primary',
                                                                                    border: '1px solid',
                                                                                    borderColor: c.border,
                                                                                    '& .MuiChip-icon': {
                                                                                        fontSize: 16,
                                                                                        color: c.icon,
                                                                                    },
                                                                                    '& .MuiChip-label': { px: 1.5 },
                                                                                }}
                                                                            />
                                                                        );
                                                                    })}
                                                                </Box>
                                                            ) : (
                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.disabled"
                                                                    fontStyle="italic"
                                                                >
                                                                    —
                                                                </Typography>
                                                            )}
                                                        </Box>

                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                flexShrink: 0,
                                                                alignItems: 'center',
                                                            }}
                                                        >
                                                            <Tooltip title={t('general.delete')} placement="top">
                                                                <IconButton
                                                                    className="return-list-delete-cached-search-button"
                                                                    size="small"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        deleteCachedSearched(cachedVal.id);
                                                                    }}
                                                                    sx={{
                                                                        width: 34,
                                                                        height: 34,
                                                                        color: 'grey.400',
                                                                        borderRadius: 1.5,
                                                                        transition: 'all 0.2s ease',
                                                                        '&:hover': {
                                                                            backgroundColor: 'error.50',
                                                                            color: 'error.main',
                                                                        },
                                                                    }}
                                                                >
                                                                    <DeleteIcon sx={{ fontSize: 18 }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        );
                                    })}
                                </Stack>
                            </>
                        ) : (
                            <SCUINoRecordComponent />
                        )}
                    </Box>
                )}
                {datas && (
                    <div style={{ height: '100%', overflow: 'auto' }}>
                        <SCUIDownloadButton
                            position="right"
                            excelData={{
                                excelDownloadData: excelDownloadDatas,
                                excelDownloadFolderName: t('orderDetail.returnList'),
                            }}
                        />
                        <SCUICustomDataGrid
                            randomId
                            rows={datas}
                            columns={columns}
                            onPageSizeChange={(i: number) => {
                                setPageNumber(0);
                                setReturnDetailFilterInput({
                                    ...returnDetailFilterInput,
                                    skip: 0,
                                    take: Number(i),
                                });
                                setPageSize(i);
                            }}
                            pageSize={pageSize}
                            paginationModeChange={paginationModeChange}
                            onPageChange={(i: number) => {
                                setPageNumber(i);
                                setReturnDetailFilterInput({
                                    ...returnDetailFilterInput,
                                    skip: Number(i),
                                });
                            }}
                            page={pageNumber}
                            rowCount={rowCount}
                            allrecord={!paginationModeChange}
                        />
                    </div>
                )}
            </SCUIContent>
        </>
    );
};
